import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';

import { units } from '@hbf/dsl';
import { PromotionalBooking } from 'ha/components/PromotionalBooking';
import { RootState } from '../types';
import {
  getIsUnlisted,
  isAvailable as isAvailableSelector,
  isAdvertiserOwner,
  getConversationLink,
  getIsBelongsToPartner,
} from '../selectors';

const useStyles = makeStyles()(() => ({
  bookingFee: {
    margin: units.yx(1, 0),
    width: '100%',
  },
}));

const mapStateToProps = (state: RootState) => ({
  isOwner: isAdvertiserOwner(state),
  isUnlisted: getIsUnlisted(state),
  isAvailable: isAvailableSelector(state),
  conversationURL: getConversationLink(state),
  isBelongsToPartner: getIsBelongsToPartner(state),
});

const PromotionalBookingContainer = () => {
  const {
    isOwner,
    isUnlisted,
    isAvailable,
    conversationURL,
    isBelongsToPartner,
  } = useSelector(mapStateToProps);
  const { classes } = useStyles();

  if ((!isOwner && conversationURL) || isBelongsToPartner) {
    return null;
  }

  if ((!isUnlisted && isAvailable) || isUnlisted || isOwner) {
    return (
      <div className={classes.bookingFee}>
        <PromotionalBooking />
      </div>
    );
  }

  return null;
};

export { PromotionalBookingContainer };
